import { createRouter, createWebHistory } from 'vue-router'
import Home from './views/Home.vue'
import Create from './views/Create.vue'
import List from './views/List.vue'
import Login from './views/Login.vue'
import Logout from './views/Logout.vue'
import Query from './views/Query.vue'
import View from './views/View.vue'
import M from 'materialize-css'
const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/create',
    name: 'Create',
    component: Create
  },
  {
    path: '/list',
    name: 'List',
    component: List
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/logout',
    name: 'Logout',
    component: Logout
  },
  {
    path: '/query',
    name: 'Query',
    component: Query
  },
  {
    path: '/view',
    name: 'View',
    component: View
  },
]
const router = createRouter({
  mode: 'history',
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  const publicPages = ['/login','/logout'];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = localStorage.getItem('username');

  // trying to access a restricted page + not logged in
  // redirect to login page
  if (authRequired && !loggedIn) {
    M.AutoInit()
    next('/login');
  } else {
    next();
  }
});

export default router